/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseInstance} from './base-instance';
import {TagDefinition} from './tag-definition';
import {LocationInstance} from './location-instance';
import {ZoneInstance} from './zone-instance';
import {Point} from './point';

export class TagInstance extends BaseInstance {
  asset: TagDefinition;
  locationInstance: LocationInstance;
  zoneInstance: ZoneInstance;
  lastZoneChangeTImestamp: Date;
  position: Point;
  is_deactivated: boolean = false;
}
